<template>
  <div class="progress-steps-container">
    <!-- Progress Steps Row -->
    <div class="progress-steps-row">
      <div
        v-for="(step, index) in steps"
        :key="index"
        class="progress-step-item"
        :class="{ 'flex-grow-1': index < steps.length - 1 }"
      >
        <div
          class="step-content"
          @click="handleSelect(index + 1)"
          :class="{ pointer: currentStep >= index + 1 }"
        >
          <div
            class="step-circle"
            :class="{
              active: currentStep === index + 1,
              completed: currentStep > index + 1,
              disabled: currentStep < index + 1,
            }"
          >
            <font-awesome-icon
              v-if="currentStep > index + 1"
              icon="check"
              class="step-check-icon"
            />
            <span v-else class="step-number">{{ index + 1 }}</span>
          </div>

          <div class="step-info">
            <div class="step-title">{{ step.displayTitle || step.title }}</div>
            <div class="step-description">{{ step.description }}</div>
          </div>
        </div>

        <div
          v-if="index < steps.length - 1"
          class="step-connector"
          :class="{ completed: currentStep > index + 1 }"
        ></div>
      </div>
    </div>

    <!-- Mobile Step Indicator -->
    <div class="mobile-step-indicator">
      <div class="current-step-info">
        <div class="current-step-title">
          {{ steps[currentStep - 1]?.displayTitle || steps[currentStep - 1]?.title }}
        </div>
        <div class="current-step-description">{{ steps[currentStep - 1]?.description }}</div>
      </div>
      <div class="step-counter">
        <small class="text-muted">Schritt {{ currentStep }} von {{ steps.length }}</small>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  steps: {
    type: Array,
    required: true,
  },
  currentStep: {
    type: Number,
    required: true,
  },
})

const emit = defineEmits(['select'])

const handleSelect = (step) => {
  emit('select', step)
}
</script>
